import useTranslation from 'next-translate/useTranslation';
import { DEFAULT_CURRENCY } from '@/constants/common';
import { ProductVariant } from '@/models/Product';
import { getVariantPricing } from '@/utils/helpers/flashSale';
import formatCurrency from '@/utils/helpers/formatCurrency';
import ButtonLabel, { VARIANT as BUTTON_VARIANT } from '../ButtonLabel';
import Caption, { VARIANT as CAPTION_VARIANT } from '../Caption';
import FlashSalePrice from './flashSale/FlashSalePrice';
interface Props {
  actualPrice?: number;
  discountedPrice?: number;
  showDiscountPercentage?: boolean;
  variant?: ProductVariant;
  onFlashSaleExpire?: () => void;
  compact?: boolean;
  hideFlashSaleDesign?: boolean;
}
const ProductPrice = ({
  actualPrice,
  discountedPrice,
  showDiscountPercentage = false,
  variant,
  onFlashSaleExpire,
  compact = false,
  hideFlashSaleDesign = false
}: Props) => {
  const {
    t
  } = useTranslation('products');
  if (variant) {
    const pricing = getVariantPricing(variant);
    if (pricing.isFlashSale && !hideFlashSaleDesign) {
      return <FlashSalePrice variant={variant} onExpire={onFlashSaleExpire} compact={compact} />;
    }
    const resolvedActual = pricing.mrp;
    const resolvedDiscounted = pricing.salePrice;
    const discountPercent = pricing.discountPercent;
    return <div className="flex items-center mt-1">
        <ButtonLabel variant={BUTTON_VARIANT.ONE} className="font-nato-semibold text-neutral-80" label={`${DEFAULT_CURRENCY}${resolvedDiscounted}`} />
        {resolvedActual !== resolvedDiscounted ? <>
            <Caption variant={CAPTION_VARIANT.TWO} className="font-nato-medium text-neutral-50 ml-1 line-through shrink-0" label={formatCurrency(resolvedActual)?.replace(/\.00$/, '')} />
            {showDiscountPercentage ? <span className="ml-1 text-xs text-[#43A314]">
                ({discountPercent}% {t('sale_off')})
              </span> : null}
          </> : null}
      </div>;
  }
  const resolvedActual = actualPrice ?? 0;
  const resolvedDiscounted = discountedPrice ?? 0;
  const discountPercent = Math.round((resolvedActual - resolvedDiscounted) / resolvedActual * 100);
  return <div className="flex items-center mt-1" data-sentry-component="ProductPrice" data-sentry-source-file="ProductPrice.tsx">
      <ButtonLabel variant={BUTTON_VARIANT.ONE} className="font-nato-semibold text-neutral-80" label={`${DEFAULT_CURRENCY}${resolvedDiscounted}`} data-sentry-element="ButtonLabel" data-sentry-source-file="ProductPrice.tsx" />
      {resolvedActual !== resolvedDiscounted ? <>
          <Caption variant={CAPTION_VARIANT.TWO} className="font-nato-medium text-neutral-50 ml-1 line-through shrink-0" label={formatCurrency(resolvedActual)?.replace(/\.00$/, '')} />
          {showDiscountPercentage ? <span className="ml-1 text-xs text-[#43A314]">
              ({discountPercent}% {t('sale_off')})
            </span> : null}
        </> : null}
    </div>;
};
export default ProductPrice;